import React from 'react'
import {ErrorBoundary} from "@webng/react-app-common";
import {ExternalUserProvider, ChannelPreview as ChannelPreviewComponent} from "@webng/comments";
import {useLiveblogWrapperClassNames} from "../LiveblogWrapper";
import {TrackingFunction} from "../LiveblogRenderContext";

interface ChannelPreviewProps {
  ownerId: string
  channelId: string
  version: number
  position?: number
  onCommentManage?: (commentId: string) => void
  externalUserProvider?: ExternalUserProvider
  useCookies?: boolean
  trackingFunction?: TrackingFunction
}

export function ChannelPreview({ownerId, channelId, externalUserProvider, version, position, onCommentManage, useCookies, trackingFunction}: ChannelPreviewProps) {
  const {className, style} = useLiveblogWrapperClassNames()

  return <ErrorBoundary>
    <ChannelPreviewComponent
      ownerId={ownerId}
      channelId={channelId}
      externalUserProvider={externalUserProvider}
      version={version}
      onCommentManage={onCommentManage}
      position={position}
      portalClassName={className}
      portalStyle={style}
      useCookies={useCookies}
      trackingFunction={trackingFunction}
    />
  </ErrorBoundary>
}


